import { useState } from 'react';
import { NavBar } from '../../components/NavBar';
import { SignIn } from '../../auth';

export function SignInPage() {
  const [startMode, setStartMode] = useState<'sign-in' | 'sign-up'>('sign-in');
  const [requestKey, setRequestKey] = useState(0);

  function showCreateAccount() {
    setStartMode('sign-up');
    setRequestKey((value) => value + 1);
  }

  return (
    <div className="auth-image-page relative min-h-[100svh] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/for-artists/photo-blue-veil.webp"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover"
          style={{ objectPosition: '68% 22%' }}
        />
        <div className="auth-image-scrim pointer-events-none absolute inset-0" />
      </div>
      <div className="relative z-10 flex min-h-[100svh] flex-col">
        <NavBar
          variant="dark"
          hideSignIn
          primaryCta={{ label: 'Create account', onClick: showCreateAccount }}
        />
        <main className="page-container flex flex-1 items-center pb-10 pt-[88px] sm:pb-12 sm:pt-24">
          <SignIn startMode={startMode} requestKey={requestKey} />
        </main>
      </div>
    </div>
  );
}
